import { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

import { APIMS } from "../../../../../../config/apims";
import ToastError from "../../../../../NotificationToast/ToastError";
import ToastSuccess from "../../../../../NotificationToast/ToastSuccess";

import "bulma/css/bulma.css";
import "../../../../../../index.css";

export default function ModalTambahTipeAcara(props) {
  const token = localStorage.getItem("token");
  const idUser = localStorage
    .getItem("id_admin")
    ?.replace(/[|&;$%@"<>()+,]/g, "");

  const [nameEvent, setNameEvent] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const fetchParams = {
    headers: {
      Authorization: `${token}`,
      "Content-Type": "application/json",
    },
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const cleanName = nameEvent.trim();

    if (!cleanName || isSubmitting) {
      return;
    }

    setIsSubmitting(true);

    try {
      const response = await APIMS.post(
        "/api/events/store",
        {
          name_event: cleanName,
          user_id: idUser,
        },
        fetchParams
      );

      if (response?.status === 201 || response?.status === 200) {
        ToastSuccess.fire({
          icon: "success",
          title: response?.data?.message || "Data berhasil disimpan",
        });

        props.GetResponseData();
        props.onHide();
      }
    } catch (error) {
      ToastError.fire({
        icon: "error",
        title: error?.response?.data?.message || "Gagal menyimpan data",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal
      show={props.show}
      onHide={props.onHide}
      centered
      backdrop="static"
      keyboard={false}
      dialogClassName="module-modal-dialog"
      contentClassName="module-modal-content"
      aria-labelledby="modal-tambah-tipe-acara"
    >
      <form onSubmit={handleSubmit}>
        <div className="module-modal-header">
          <div>
            <h5 id="modal-tambah-tipe-acara" className="module-modal-title">
              Tambah Tipe Acara
            </h5>
           
          </div>

          <button
            type="button"
            className="module-modal-close"
            onClick={props.onHide}
            disabled={isSubmitting}
            aria-label="Tutup modal"
          >
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </div>

        <Modal.Body className="module-modal-body mt-1 mx-2">
          <div className="module-form-grid">
            <div className="module-form-group module-form-span-2">
              <label className="module-form-label" htmlFor="name_event_add">
                Tipe Acara <span>*</span>
              </label>
              <input
                id="name_event_add"
                className="module-form-input"
                autoFocus
                type="text"
                name="name_event"
                value={nameEvent}
                onChange={(event) => setNameEvent(event.target.value)}
                
                disabled={isSubmitting}
                required
              />
            </div>
          </div>
        </Modal.Body>

        <div className="module-modal-footer">
          <button
            type="button"
            className="module-modal-cancel"
            onClick={props.onHide}
            disabled={isSubmitting}
          >
            Batal
          </button>

          <button
            type="submit"
            className="module-modal-submit"
            disabled={isSubmitting || !nameEvent.trim()}
          >
            {isSubmitting && <span className="module-button-spinner" />}
            {isSubmitting ? "Menyimpan..." : "Tambahkan"}
          </button>
        </div>
      </form>
    </Modal>
  );
}
